import { ReduxStore } from "@interfaces/store";
import { useSelector } from "react-redux";

export function useDailyGifts() {
    return useSelector(({ user: { daily } }: ReduxStore) => daily.gifts);
}